import { Type } from '@spotify-internal/encore-web';
import { Fragment, useEffect } from 'react';
import * as H from 'history';

import { TranslationProps } from 'etc/types';
import withTranslation from 'lib/shared/i18n/withTranslation';
import analytics, {
  StepLabel,
} from 'components/ContentReporting/ContentPolicyReporting/policy-reporting-analytics-utils';

export interface Step3SuccessProps extends TranslationProps {
  location: H.Location;
}

const Step3Success = ({ t, location }: Step3SuccessProps): JSX.Element => {
  useEffect(
    () => analytics.trackVirtualPageView(location.pathname, location.search, StepLabel.Step3ThankYou),
    [location.pathname, location.search],
  );

  return (
    <Fragment>
      <Type.h1 paddingBottom="0.67em" variant="altoBrio">
        {t('form_submission_success_title')}
      </Type.h1>
      <Type.p>{t('form_submission_success_subtitle')}</Type.p>
      <Type.p>{t('form_submission_success_body')}</Type.p>
    </Fragment>
  );
};

export default withTranslation('content_policy_reporting')(Step3Success);
